import { ActionFormat } from '../actions/actionFormats'
import * as actionTypes from '../actionTypes/notificationActionTypes'

export function showSuccessNotification(msg: string): ActionFormat {
  return {
    type: actionTypes.SHOW_NOTIFICATION_SUCCESS,
    payload: msg,
  }
}

export function showErrorNotification(msg: string): ActionFormat {
  return {
    type: actionTypes.SHOW_NOTIFICATION_ERROR,
    payload: msg,
  }
}

export function hideNotification(): ActionFormat {
  return {
    type: actionTypes.HIDE_NOTIFICATION,
  }
}
